import React from "react";

const SeasonalFill = props => (
  <svg viewBox="0 0 21 21" fill="none" {...props}>
    <path
      d="M13.656 4.563L16 5.5l.938 2.344c.078.117.156.195.312.195.117 0 .195-.078.273-.195L18.5 5.5l2.305-.938c.117-.078.195-.156.195-.312 0-.117-.078-.195-.195-.273L18.5 3 17.523.695C17.445.578 17.367.5 17.211.5c-.117 0-.195.078-.273.195L16 3l-2.344.977c-.117.078-.195.156-.195.273 0 .156.078.234.195.313zm7.149 11.914L18.5 15.5l-.977-2.305c-.078-.117-.156-.195-.312-.195-.117 0-.195.078-.273.195L16 15.5l-2.344.977c-.117.078-.195.156-.195.312 0 .117.078.195.195.273L16 18l.938 2.344c.078.117.156.195.312.195.117 0 .195-.078.273-.195L18.5 18l2.305-.938c.117-.078.195-.156.195-.312 0-.117-.078-.195-.195-.273zM16 10.5c-.04-.234-.156-.469-.352-.547l-4.414-2.226-2.187-4.375c-.235-.43-.899-.43-1.133 0L5.727 7.727 1.312 9.953c-.195.078-.351.313-.351.547 0 .234.156.469.352.547l4.414 2.226 2.187 4.415c.117.195.313.312.586.312.234 0 .43-.117.547-.313l2.187-4.414 4.414-2.226c.196-.078.352-.313.352-.547z"
      fill="currentColor"
    />
  </svg>
);

export default SeasonalFill;
